import React, { useContext, useEffect, useRef, useState } from 'react';
import { FaStar, FaUserCircle, FaVideo } from 'react-icons/fa';
import { IoIosArrowBack, IoIosArrowForward } from 'react-icons/io';
import { RiVerifiedBadgeFill } from 'react-icons/ri';
import { Link, useNavigate } from 'react-router-dom';
import { MyContext } from '../../Context/MyProvider';
import axios from 'axios';
import briefcaseicon from "../../assets/Icon/briefcase.svg";
import { useTranslation } from 'react-i18next';
import Loading from '../Loading';
import secureLocalStorage from "react-secure-storage";
const DocDetail = () => {

    const { t } = useTranslation();

    const { ApiBaseUrl, ImgBaseUrl } = useContext(MyContext);
    const site_currency = secureLocalStorage.getItem("currency");
    const currency = site_currency ? site_currency : "$";

    const [personeData, setPersoneData] = useState([]);
    const [videoData, setVideoData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [apiloading, setApiLoading] = useState(false);
    const [page, setPage] = useState(1);

    const navigate = useNavigate();
    const hasReachedBottom = useRef(false);
    const NoMoreDataRef = useRef(true);
    const selectBtnRef = useRef(0);

    const Data = sessionStorage.getItem("Docdetails");
    if (Data) {
        var { title, path, pagename, id } = JSON.parse(Data);
    }

    const NavigateHandle = (title, Id) => {
        navigate("/doctor-profile");
        sessionStorage.setItem("Docprofile", JSON.stringify({ id: Id, department_id: id, title: title, path: "/doctor-details", pagename: "Doctor Details" }));
    };

    useEffect(() => {
        window.scrollTo(0, 0);
        HandlefetchInPersonData(1);
    }, []);

    const HandlefetchInPersonData = (page) => {
        setApiLoading(true);
        navigator.geolocation.getCurrentPosition(position => {

            const lat = String(position.coords.latitude);
            const long = String(position.coords.longitude);

            axios.post(`${ApiBaseUrl}/customer/dep_type_client_doctor`, { department_id: id, lat: lat, lon: long, page })
                .then((res) => {
                    const { clinic_visit, ResponseCode } = res.data;
                    // console.log("dep_type_client_doctor", res);
                    if (ResponseCode === 200) {
                        if (clinic_visit.length === 0) NoMoreDataRef.current = false;
                        if (page === 1) {
                            setPersoneData(clinic_visit);
                        } else {
                            setPersoneData(prev => [...prev, ...clinic_visit]);
                        }
                    }
                    setLoading(false);
                    setApiLoading(false);
                })
                .catch((error) => {
                    console.error(error);
                });
        });

    }

    const HandlefetchVideoData = (page) => {
        navigator.geolocation.getCurrentPosition(position => {
            const lat = String(position.coords.latitude);
            const long = String(position.coords.longitude);

            axios.post(`${ApiBaseUrl}/customer/dep_type_video_doctor`, { department_id: id, lat: lat, lon: long, page })
                .then((res) => {
                    const { video_consult, ResponseCode } = res.data;
                    // console.log("dep_type_video_doctor", res);
                    if (ResponseCode === 200) {
                        if (video_consult.length === 0) NoMoreDataRef.current = false;
                        if (page === 1) {
                            setVideoData(video_consult);
                        } else {
                            setVideoData(prev => [...prev, ...video_consult]);
                        }
                    }
                    setApiLoading(false);
                })
                .catch((error) => {
                    console.error(error);
                });
        });

    }

    useEffect(() => {
        const handleScroll = () => {
            const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
            const scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
            const clientHeight = window.innerHeight;

            const isAtBottom = scrollTop + clientHeight >= scrollHeight - 100;

            if (isAtBottom && !hasReachedBottom.current && NoMoreDataRef.current) {
                hasReachedBottom.current = true;
                setPage(prev => prev + 1);
  
            } else if (!isAtBottom && hasReachedBottom.current) {
                hasReachedBottom.current = false;
            }
        };

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    useEffect(() => {
        if (page === 1 || !NoMoreDataRef.current) return;

        if (selectBtnRef.current === 0) {
            HandlefetchInPersonData(page);
        } else {
            HandlefetchVideoData(page);
        }
    }, [page])

    const HandleSelectButton = (index) => {
        selectBtnRef.current = index;
        NoMoreDataRef.current = true;
        setPage(1);
        setApiLoading(true);

        if (index === 0) {
            HandlefetchInPersonData(1);
        } else {
            HandlefetchVideoData(1);
        }
    };
    return (
        <div>
            {loading
                ? <Loading CustomeStyle="fixed left-0 top-0 h-[100vh] w-full flex items-center justify-center bg-white" />
                : <div className="width-container details max-_430_:pb-0">

                    <div className="flex items-center justify-between top-section">
                        <Link to="/" className="flex items-center gap-[5px] border-[2px] border-gray-200 rounded-[50px] px-[10px] group py-[4px] hover:bg-black">
                            <IoIosArrowBack className=' group-hover:text-white' />
                            <h1 className='font-[500] group-hover:text-white'> {t("Go Home")}</h1>
                        </Link>
                        <div className="flex items-center gap-[10px] max-_430_:hidden">
                            <Link to={path} className='font-[500] text-gray-700'>{t(pagename)}</Link>
                            <IoIosArrowForward />
                            <h1 className='font-[500] text-gray-400 pagename'>{title}</h1>
                        </div>
                        <div className="border-[2px] border-gray-200 rounded-[50px] px-[20px] py-[2px] hidden max-_430_:block">
                            <Link to={path} className='font-[500] text-gray-600'>{t("Back")}</Link>
                        </div>
                    </div>

                    <div className="flex justify-center mt-[25px]">
                        <div className="bg-[#F6F7F8] Select-btn p-[5px] rounded-[50px] flex gap-[20px]">
                            <button onClick={() => HandleSelectButton(0)} className={`${selectBtnRef.current === 0 && "active"} text-black`}><FaUserCircle className='text-[20px]' />{t("In Person")}</button>
                            <button onClick={() => HandleSelectButton(1)} className={`${selectBtnRef.current === 1 && "active"} text-black`}><FaVideo className='text-[20px]' />{t("Video Visit")}</button>
                        </div>
                    </div>

                    {apiloading
                        ? <Loading CustomeStyle="h-[500px] w-full flex items-center justify-center bg-white" />
                        : <div className="mt-[30px] flex flex-wrap items-center gap-[20px]">

                            {selectBtnRef.current === 0 && (personeData.length >= 1 ? personeData.map((item, index) => {
                                return <div key={index} onClick={() => NavigateHandle(item.title, item.id)} className="doctor-box overflow-hidden">
                                    <div className="relative">
                                        <img className='w-[100%] h-[280px] object-cover group-hover:scale-[1.2] duration-[0.5s]' src={ImgBaseUrl + item.logo} alt="Doctor img" />
                                        <div className="absolute top-[5px] left-[5px] flex items-center gap-[5px] rating_blur">
                                            <FaStar className='text-yellow-500' />
                                            <span className='font-[500] text-white'>
                                                {item.avg_star != null ? Number(item.avg_star).toFixed(1) : "0.0"}
                                            </span>
                                        </div>
                                    </div>
                                    <div className="py-[10px] px-[15px]">
                                        <div className="border-b-[1px] border-gray-300 pb-[10px]">
                                            <div className="flex items-center gap-[5px]">
                                                <h1 className='font-bold text-[20px] whitespace-nowrap overflow-hidden overflow-ellipsis max-w-[95%]'>{item.title}</h1>
                                                <RiVerifiedBadgeFill className='text-green-500 text-[25px]' />
                                            </div>
                                            <span className='font-[500] text-[16px]'>{item.subtitle}</span>
                                        </div>
                                        <div className="">
                                            <div className="flex items-center mt-[10px] scroll-container">
                                                <div className="details-box me-[7px]">
                                                    <div className="icon-box">
                                                        <img src={briefcaseicon} className='min-w-[25px]' alt="briefcase" />
                                                    </div>
                                                    <div className="details">
                                                        <h1>{t("Total Experience")}</h1>
                                                        <span>{item.year_of_experience}+ Years</span>
                                                    </div>
                                                </div>
                                                <div className="line"></div>
                                                <div className="details-box">
                                                    <div className="icon-box">
                                                        <FaStar className='text-[20px] text-[#28303F]' />
                                                    </div>
                                                    <div className="details">
                                                        <h1>{t("Rating")}</h1>
                                                        <span>{item.avg_star}.0 ({item.tot_review})</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="flex items-center mt-[10px] scroll-container">
                                                <div className="details-box">
                                                    <div className="icon-box">
                                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="#28303F" xmlns="http://www.w3.org/2000/svg">
                                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM12 11.25C11.3096 11.25 10.75 10.6904 10.75 10C10.75 9.30964 11.3096 8.75 12 8.75C12.6904 8.75 13.25 9.30964 13.25 10C13.25 10.4142 13.5858 10.75 14 10.75C14.4142 10.75 14.75 10.4142 14.75 10C14.75 8.74122 13.9043 7.67998 12.75 7.35352V6.5C12.75 6.08579 12.4142 5.75 12 5.75C11.5858 5.75 11.25 6.08579 11.25 6.5V7.35352C10.0957 7.67998 9.25 8.74122 9.25 10C9.25 11.5188 10.4812 12.75 12 12.75C12.6904 12.75 13.25 13.3096 13.25 14C13.25 14.6904 12.6904 15.25 12 15.25C11.3096 15.25 10.75 14.6904 10.75 14C10.75 13.5858 10.4142 13.25 10 13.25C9.58579 13.25 9.25 13.5858 9.25 14C9.25 15.2588 10.0957 16.32 11.25 16.6465V17.5C11.25 17.9142 11.5858 18.25 12 18.25C12.4142 18.25 12.75 17.9142 12.75 17.5V16.6465C13.9043 16.32 14.75 15.2588 14.75 14C14.75 12.4812 13.5188 11.25 12 11.25Z" />
                                                        </svg>
                                                    </div>
                                                    <div className="details me-[4px]">
                                                        <h1>{t("Consultation Fee")}</h1>
                                                        <span>{currency}{item.min_inp_price} - {currency}{item.max_inp_price}</span>
                                                    </div>
                                                </div>
                                                <div className="line"></div>
                                                <div className="details-box">
                                                    <div className="icon-box">
                                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M2 8C2 5.79086 3.79086 4 6 4H12C14.2091 4 16 5.79086 16 8V16C16 18.2091 14.2091 20 12 20H6C3.79086 20 2 18.2091 2 16V8ZM13 9C13 10.1046 12.1046 11 11 11C9.89543 11 9 10.1046 9 9C9 7.89543 9.89543 7 11 7C12.1046 7 13 7.89543 13 9ZM18.5409 16.3103L17.5 15.1999V8.79993L18.5409 7.68961C19.781 6.3669 22 7.24442 22 9.05749V14.9424C22 16.7554 19.781 17.633 18.5409 16.3103Z" fill="#28303F" />
                                                        </svg>
                                                    </div>
                                                    <div className="details">
                                                        <h1>{t("Video Visit")}</h1>
                                                        <span>{currency}{item.min_vid_price} - {currency}{item.max_vid_price}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <button className='book-btn'>{t("Book Appointment")}</button>
                                    </div>
                                </div>
                            })
                                : <div className='w-[100%] h-[300px] flex items-center justify-center'>
                                    <h1 className='font-[500] text-[20px]'>{t("No Doctor available in your area.")}</h1>
                                </div>
                            )}

                            {selectBtnRef.current === 1 && (videoData.length >= 1 ? personeData.map((item, index) => {
                                return <div key={index} onClick={() => NavigateHandle(item.title, item.id)} className="doctor-box overflow-hidden">
                                    <div className="relative">
                                        <img className='w-[100%] h-[280px] object-cover group-hover:scale-[1.2] duration-[0.5s]' src={ImgBaseUrl + item.logo} alt="Doctor img" />
                                        <div className="absolute top-[5px] left-[5px] flex items-center gap-[5px] rating_blur">
                                            <FaStar className='text-yellow-500' />
                                            <span className='font-[500] text-white'>
                                                {item.avg_star != null ? Number(item.avg_star).toFixed(1) : "0.0"}
                                            </span>
                                        </div>
                                    </div>
                                    <div className="py-[10px] px-[15px]">
                                        <div className="border-b-[1px] border-gray-300 pb-[10px]">
                                            <div className="flex items-center gap-[5px]">
                                                <h1 className='font-bold text-[20px] whitespace-nowrap overflow-hidden overflow-ellipsis max-w-[95%]'>{item.title}</h1>
                                                <RiVerifiedBadgeFill className='text-green-500 text-[25px]' />
                                            </div>
                                            <span className='font-[500] text-[16px]'>{item.subtitle}</span>
                                        </div>
                                        <div className="">
                                            <div className="flex items-center mt-[10px] scroll-container">
                                                <div className="details-box me-[7px]">
                                                    <div className="icon-box">
                                                        <img src={briefcaseicon} className='min-w-[25px]' alt="briefcase" />
                                                    </div>
                                                    <div className="details">
                                                        <h1>{t("Total Experience")}</h1>
                                                        <span>{item.year_of_experience}+ Years</span>
                                                    </div>
                                                </div>
                                                <div className="line"></div>
                                                <div className="details-box">
                                                    <div className="icon-box">
                                                        <FaStar className='text-[20px] text-[#28303F]' />
                                                    </div>
                                                    <div className="details">
                                                        <h1>{t("Rating")}</h1>
                                                        <span>{item.avg_star}.0 ({item.tot_review})</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="flex items-center mt-[10px] scroll-container">
                                                <div className="details-box">
                                                    <div className="icon-box">
                                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="#28303F" xmlns="http://www.w3.org/2000/svg">
                                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM12 11.25C11.3096 11.25 10.75 10.6904 10.75 10C10.75 9.30964 11.3096 8.75 12 8.75C12.6904 8.75 13.25 9.30964 13.25 10C13.25 10.4142 13.5858 10.75 14 10.75C14.4142 10.75 14.75 10.4142 14.75 10C14.75 8.74122 13.9043 7.67998 12.75 7.35352V6.5C12.75 6.08579 12.4142 5.75 12 5.75C11.5858 5.75 11.25 6.08579 11.25 6.5V7.35352C10.0957 7.67998 9.25 8.74122 9.25 10C9.25 11.5188 10.4812 12.75 12 12.75C12.6904 12.75 13.25 13.3096 13.25 14C13.25 14.6904 12.6904 15.25 12 15.25C11.3096 15.25 10.75 14.6904 10.75 14C10.75 13.5858 10.4142 13.25 10 13.25C9.58579 13.25 9.25 13.5858 9.25 14C9.25 15.2588 10.0957 16.32 11.25 16.6465V17.5C11.25 17.9142 11.5858 18.25 12 18.25C12.4142 18.25 12.75 17.9142 12.75 17.5V16.6465C13.9043 16.32 14.75 15.2588 14.75 14C14.75 12.4812 13.5188 11.25 12 11.25Z" />
                                                        </svg>
                                                    </div>
                                                    <div className="details me-[4px]">
                                                        <h1>{t("Consultation Fee")}</h1>
                                                        <span>{currency}{item.min_inp_price} - {currency}{item.max_inp_price}</span>
                                                    </div>
                                                </div>
                                                <div className="line"></div>
                                                <div className="details-box">
                                                    <div className="icon-box">
                                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M2 8C2 5.79086 3.79086 4 6 4H12C14.2091 4 16 5.79086 16 8V16C16 18.2091 14.2091 20 12 20H6C3.79086 20 2 18.2091 2 16V8ZM13 9C13 10.1046 12.1046 11 11 11C9.89543 11 9 10.1046 9 9C9 7.89543 9.89543 7 11 7C12.1046 7 13 7.89543 13 9ZM18.5409 16.3103L17.5 15.1999V8.79993L18.5409 7.68961C19.781 6.3669 22 7.24442 22 9.05749V14.9424C22 16.7554 19.781 17.633 18.5409 16.3103Z" fill="#28303F" />
                                                        </svg>
                                                    </div>
                                                    <div className="details">
                                                        <h1>{t("Video Visit")}</h1>
                                                        <span>{currency}{item.min_vid_price} - {currency}{item.max_vid_price}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <button className='book-btn'>{t("Book Appointment")}</button>
                                    </div>
                                </div>
                            })
                                : <div className='w-[100%] h-[300px] flex items-center justify-center'>
                                    <h1 className='font-[500] text-[20px]'>{t("No Doctor available in your area.")}</h1>
                                </div>
                            )}

                        </div>}
                </div>}
        </div>
    )
}

export default DocDetail